<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="dark bg-gray-900 print:hidden"
  [appearance]="navigationAppearance"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.default"
  [opened]="!isScreenSmall">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo -->
    <div class="flex items-center p-4 pl-6 h-20">
      @if (brand?.icon) {
        <img
          class="w-8"
          [src]="brand.icon">
      }
    </div>
  </ng-container>
  <!-- Navigation footer hook -->
  <ng-container fuseVerticalNavigationContentFooter>
    @if (navigationAppearance === 'default') {
      <div class="flex flex-0 items-center justify-center h-16 pr-6 pl-2 mt-2 mb-4 opacity-50">
        @if (brand?.logo) {
          <img
            class="max-w-36"
            [src]="getLogoUrl('dark')">
        }
        @if (!brand?.logo) {
          <img
            src="assets/images/logo/logo-gc.png">
          }
        </div>
      }
    </ng-container>
  </fuse-vertical-navigation>

  <!-- Wrapper -->
  <div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
      <div class="flex items-center pr-2 space-x-2">
        <!-- Navigation toggle button -->
        <button
          mat-icon-button
          (click)="toggleNavigation('mainNavigation')">
          <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>
        <!-- Navigation appearance toggle button -->
        <button
          class="hidden md:inline-flex"
          mat-icon-button
          (click)="toggleNavigationAppearance()">
          <mat-icon [svgIcon]="'heroicons_outline:switch-horizontal'"></mat-icon>
        </button>
      </div>
      <!-- Components -->
      <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
        <user></user>
        <languages></languages>
        <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
        <settings></settings>
        <messages></messages>
        <clipboard></clipboard>
        <system-changes></system-changes>
        <ws-messages></ws-messages>
      </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
      <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
      Otherwise, layout changes won't be registered and the view won't be updated! -->
      @if (true) {
        <router-outlet></router-outlet>
      }
    </div>

    <!-- Footer -->
    <!-- <div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
    <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
  </div> -->

</div>
